const DECISION_OPTS = [["all", "All decisions"], ["pending", "Pending"], ["accepted", "Accepted"], ["rejected", "Rejected"]];
const B1_OPTS = [["all", "All levels"], ["b1", "B1 reached"], ["not-b1", "Not yet B1"]];

function Group({ label, opts, value, onChange, name }) {
  return (
    <div className="flex flex-wrap items-center gap-2" role="radiogroup" aria-label={label}>
      <span className="overline mr-1">{label}</span>
      {opts.map(([id, text]) => (
        <button
          key={id}
          type="button"
          role="radio"
          aria-checked={value === id}
          onClick={() => onChange(id)}
          data-testid={`filter-${name}-${id}`}
          className={`px-3 py-1.5 text-xs font-bold border transition-colors ${value === id ? "bg-foreground text-background border-foreground" : "neu-btn"}`}
        >
          {text}
        </button>
      ))}
    </div>
  );
}

export function AttemptFilters({ decision, b1, onDecision, onB1, shown, total }) {
  return (
    <div className="mb-5 flex flex-col gap-3" data-testid="attempt-filters">
      <Group label="Decision" name="decision" opts={DECISION_OPTS} value={decision} onChange={onDecision} />
      <Group label="Level" name="b1" opts={B1_OPTS} value={b1} onChange={onB1} />
      <div className="text-xs text-muted-foreground" data-testid="attempt-filters-count">Showing {shown} of {total} results</div>
    </div>
  );
}
